export default __webpack_public_path__ + "static/media/saint_aubin17.24845dd2.jpg";